import {Component, ViewChild} from '@angular/core';
import {
  AlertController,
  Navbar,
  NavController,
  NavParams,
  Platform,
  PopoverController,
  ViewController
} from 'ionic-angular';
import {PruefungAllgemeinPage} from "../pruefung-allgemein/pruefung-allgemein";
import {PruefungKundePage} from "../pruefung-kunde/pruefung-kunde";
import {PruefungPdfPage} from "../pruefung-pdf/pruefung-pdf";
import {PruefungStandortPage} from "../pruefung-standort/pruefung-standort";
import {PruefungProtokollePage} from "../pruefung-protokolle/pruefung-protokolle";
import {AnmerkungstextvorlagenPage} from "../anmerkungstextvorlagen/anmerkungstextvorlagen";
import {LoadingServiceProvider} from "../../providers/loading-service/loading-service";
import {Subscription} from "rxjs/Subscription";
import {AutoUnsubscribe} from "ngx-auto-unsubscribe";
import {Network} from "@ionic-native/network";
import {HttpClient} from "@angular/common/http";
import "rxjs/add/operator/take";
import {GlobalProvider} from "../../providers/global/global";
import {ProtocolService} from "../../store/protocol/protocol.service";
import {AuditService} from "../../store/audit/audit.service";
import {AuditEntity} from "../../store/audit/audit.entity";
import {ContactEntity} from "../../store/contact/contact.entity";
import {ContactService} from "../../store/contact/contact.service";
import {LocationService} from "../../store/location/location.service";

/**
 * Generated class for the PruefungPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
@AutoUnsubscribe()
// @IonicPage({
//   segment: 'pruefung/:pruefungId'
// })
@Component({
  selector: 'page-pruefung',
  templateUrl: 'pruefung.html',
})
export class PruefungPage {


  @ViewChild("content") contentCtrl: NavController;
  @ViewChild(Navbar) navbar: Navbar;
  private customerId: number;
  public customer: any;
  private pruefung: any;
  public isOwner: boolean = false;

  public activePage: string = 'PruefungAllgemeinPage';
  public isTablet: boolean = false;
  public isLandscape: boolean = false;
  public isDesktop: boolean = false;

  // public contentArea = PruefungAllgemeinPage;

  private pruefung_id: string = null;
  private pruefungSubscriber: Subscription;
  private customerSubscriber: Subscription;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              // private pruefungProvider: PruefungProvider,
              // private customerProvider: CustomerProvider,
              private loadingProvider: LoadingServiceProvider,
              public plt: Platform,
              // private dataProvider: DataProvider,
              private network: Network,
              private http: HttpClient,
              private popoverCtrl: PopoverController,
              private alertCtrl: AlertController,
              // private protokollProvider: ProtokollProvider,
              private globalProvider: GlobalProvider,
              // private standortProvider: StandortProvider,
              private auditService: AuditService,
              private contactService: ContactService,
              private locationService: LocationService,
              private protocolService: ProtocolService) {

    this.pruefung_id = navParams.get('pruefungId');

    this.pruefungSubscriber = this.auditService.getById(this.pruefung_id)
      .map((audit: AuditEntity) => {
        this.pruefung = audit;
        this.isOwner = this.pruefung.ownerId === this.globalProvider.user.uuid;
        return audit;
      })
      .flatMap((audit: AuditEntity) => this.contactService.getById(audit.customerId))
      .subscribe((contact: ContactEntity) => {
        this.customer = contact;
      });


    // this.pruefungSubscriber = pruefungProvider.getById(this.pruefung_id)
    //   .subscribe((pruefung) => {
    //     //check if we have a pruefung, otherwise it was deleted;
    //     if(pruefung){
    //       this.pruefung = pruefung;
    //       if(this.pruefung.ownerId === this.globalProvider.user.uuid){
    //         this.isOwner = true;
    //       }else {
    //         //disable all inputs
    //         // let elementsToDisable = document.querySelectorAll("page-pruefung input, page-pruefung ion-select, page-pruefung ion-datetime");
    //         // for(let i = 0, length = elementsToDisable.length; i < length; i++){
    //         //   let element = elementsToDisable[i];
    //         //   element.setAttribute('disabled', 'true');
    //         // }
    //       }
    //       // this.isOwner = true;
    //
    //
    //
    //       this.customerSubscriber = this.customerProvider.getById(this.pruefung.customerId)
    //         .take(1)
    //         .subscribe((customer) => {
    //           this.customer = customer;
    //         });
    //     }else {
    //       console.log('pruefung was deleted');
    //     }
    //   })





    this.isTablet = plt.is('tablet');
    this.isDesktop = plt.is('core');

    this.isLandscape = plt.isLandscape();

  }

  ionViewDidLoad() {
    this.loadingProvider.dismiss();
    let selectProtokollId = this.navParams.get('protokollId');
    if(selectProtokollId){
      this.openProtokolle(selectProtokollId);
    }
    else{
      this.openAllgemein();
    }
  }


  ionViewWillLeave() {
    // this.pruefungSubscriber.unsubscribe();
    // this.customerSubscriber.unsubscribe();
  }

  public close(): void {
    //todo: wenn die Prüfung keine Protokolle beim verlassen beinhaltet, dann pruefung hart löschen

    if(this.pruefung && this.pruefung.protokolle && this.pruefung.protokolle.length === 0){
      this.auditService.remove(this.pruefung, false);
     // this.dataProvider.hardDeleteDocument(this.pruefung);
    }
    this.navCtrl.pop();
  }

  ionViewDidEnter() {
    console.log('test');
  }

  public openAllgemein(): void {
      this.contentCtrl.setRoot(PruefungAllgemeinPage, {pruefungId: this.pruefung_id}, {animate: true, direction: 'forward'});
      this.activePage = 'allgemein';
  }

  public openKunde(): void {
      this.contentCtrl.setRoot(PruefungKundePage, {pruefungId: this.pruefung._id}, {animate: true, direction: 'forward'});
      this.activePage = 'kunde';
  }

  public openStandorte(): void {
      this.contentCtrl.setRoot(PruefungStandortPage, {customer: this.customer, pruefung: this.pruefung}, {animate: true, direction: 'forward'});
      this.activePage = 'standorte';
  }

  public openProtokolle(selectProtokollId = ''): void {
    this.contentCtrl.setRoot(PruefungProtokollePage, {customer: this.customer, pruefung: this.pruefung, protokollId: selectProtokollId}, {animate: true, direction: 'forward'});
    this.activePage = 'protokolle';
  }

  public openAnmerkungen(): void {
    this.contentCtrl.setRoot(AnmerkungstextvorlagenPage, {pruefung: this.pruefung}, {animate: true, direction: 'forward'});
    this.activePage = 'anmerkungen';
  }

  public openPdf(): void {
    this.contentCtrl.setRoot(PruefungPdfPage, {customer: this.customer, pruefung: this.pruefung}, {animate: true, direction: 'forward'});
    this.activePage = 'pdf';
  }

  public showOwnerInformation(): void {
    let alert = this.alertCtrl.create({
      title: 'Dokument ist gesperrt',
      subTitle: 'Das Dokument ist zur Bearbeitung für Sie gesperrt. Bitte wenden Sie sich an: ' + this.pruefung.ownerId,
      buttons: ['OK']
    });
    alert.present();
  }

  public share(event): void {

    //check Connection
    //if networkconnection available -> get TeamMembers and exlude current owner.
    //after select -> rewrite owner of pruefung to
    if(this.network.type !== 'none'){
      //request Teammember and exclude owner
      this.http.post(this.globalProvider.apiURL+'/v1/teammembers', {userUUID: this.globalProvider.user.uuid, databaseUUID: this.globalProvider.database.uuid})
        .subscribe((response: any) => {
          if(response.meta.success){
            let availableShareUsers = response.data.availableShareUsers;
            let sharePopover = this.popoverCtrl.create(SharePruefungPopover, {availableShareUsers: availableShareUsers});
            sharePopover.onDidDismiss((response) => {
              if(response){
                console.log('share data with user: ');
                console.dir(response.selectedShareUser);
                //we have now the needed information to set the ownerId of this document. @refercenced customer add the selectedShareUser
                let customerId = this.pruefung.customerId;
                if(!this.pruefung.hasOwnProperty('readers')){
                  this.pruefung['readers'] = [];
                }

                this.pruefung.readers = this.pruefung.readers.filter((reader) => {
                  return reader !== response.selectedShareUser.userUUID;
                });
                this.pruefung.readers.push(response.selectedShareUser.userUUID);
                this.pruefung['ownerId'] = response.selectedShareUser.userUUID;

                this.customer.readers = this.customer.readers.filter((reader) => {
                  return reader !== response.selectedShareUser.userUUID;
                });
                this.customer.readers.push(response.selectedShareUser.userUUID);

                this.locationService.getByCustomerId(this.pruefung.customerId)
                  .take(1)
                  .subscribe((standorte: Array<any>) => {
                    for(let standort of standorte){
                      standort.readers = standort.readers.filter((reader) => {
                        return reader !== response.selectedShareUser.userUUID;
                      });
                      standort.readers.push(response.selectedShareUser.userUUID);
                      this.locationService.set(standort, false);
                      // this.dataProvider.updateDocument(standort);
                    }
                  })

                // this.standortProvider.getByCustomerId(this.pruefung.customerId)
                //   .take(1)
                //   .subscribe((standorte: Array<any>) => {
                //     for(let standort of standorte){
                //       standort.readers = standort.readers.filter((reader) => {
                //         return reader !== response.selectedShareUser.userUUID;
                //       });
                //       standort.readers.push(response.selectedShareUser.userUUID);
                //       this.dataProvider.updateDocument(standort);
                //     }
                //   })

                this.protocolService.getByIds(this.pruefung.protokolle)
                  .take(1)
                  .subscribe((protokolle) => {
                    for(let protokoll of protokolle){
                      protokoll['ownerId'] = response.selectedShareUser.userUUID;
                      protokoll.readers = protokoll.readers.filter((reader) => {
                        return reader !== response.selectedShareUser.userUUID;
                      })
                      protokoll.readers.push(response.selectedShareUser.userUUID);
                      this.protocolService.set(protokoll, false);
                    }
                  });

                // this.protokollProvider.getByIds(this.pruefung.protokolle)
                //   .take(1)
                //   .subscribe((protokolle) => {
                //     for(let protokoll of protokolle){
                //       protokoll['ownerId'] = response.selectedShareUser.userUUID;
                //       protokoll.readers = protokoll.readers.filter((reader) => {
                //         return reader !== response.selectedShareUser.userUUID;
                //       })
                //       protokoll.readers.push(response.selectedShareUser.userUUID);
                //       this.dataProvider.updateDocument(protokoll);
                //     }
                //   });

                this.contactService.set(this.customer, false);
                this.auditService.set(this.pruefung, false);

                // this.dataProvider.updateDocument(this.customer);
                // this.dataProvider.updateDocument(this.pruefung);

                this.close();

              }
            })
            sharePopover.present({
              ev: event
            });
          } else {
            //alert error
          }
        })
    }else {
      //alert user, that we need a network connection
    }
  }

  // If you work with AOT this method must be present, even if empty!
  // Otherwise 'ng build --prod' will optimize away any calls to ngOnDestroy,
  // even if the method is added by the @AutoUnsubscribe decorator
  ngOnDestroy() {
    // You can also do whatever you need here
  }

}


@Component({
  selector: 'add-foto-popover',
  template: `<ion-list><ion-list-header>Pruefung übertragen an:</ion-list-header><ion-item *ngFor="let availableShareUser of availableShareUsers" (click)="close(availableShareUser)">{{availableShareUser.userMail}}</ion-item></ion-list>`
})
export class SharePruefungPopover {

  public availableShareUsers: Array<{}>;
  constructor(public viewCtrl: ViewController, private navParams: NavParams) {
    this.availableShareUsers = this.navParams.get('availableShareUsers');
  }

  public close(selectedShareUser): void {
    this.viewCtrl.dismiss({selectedShareUser: selectedShareUser});
  }
}



// WEBPACK FOOTER //
// ./src/pages/pruefung/pruefung.ts